import { LineaDeBolsa } from '../../../types';
import { LineaCotizacion } from '../types';

// SPEC-195 (CA-024) — línea del resumen de bolsas (selector y franja del detalle). El subtotal es
// el que devuelve la API (precio de venta × cantidad, RN-006); sin él (fixtures previos al
// campo), precio de lista × cantidad como antes.
export function aLineaResumen(l: LineaCotizacion): LineaDeBolsa {
  return {
    id: l.id,
    producto_id: l.productoId,
    cantidad: l.cantidad,
    precio_unitario: l.precioUnitario,
    subtotal: l.subtotal ?? l.precioUnitario * l.cantidad,
    nombre_producto: l.nombre,
    imagen_url: l.imagenUrl ?? undefined,
  };
}
